// extracted by mini-css-extract-plugin
export default {"input":"label-with-date_input__XjuSR","placeHolderShimmer":"label-with-date_placeHolderShimmer__UPFwl"};